import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Helmet from 'react-helmet'
import '../../../styles/base.css'

import ConfigManager from '../config-manager'
import Header from '../header'
import Footer from '../footer'
import { isDevelopment } from '../../../utilities/dev'

const scope = 'Page'
class Page extends Component {
  _createTitle(pageTitle) {
    const { config, title } = this.props
    if (config.siteName && title) {
      return `${title} - ${config.siteName}`
    } else if (config.siteName) {
      return config.siteName
    }
  }

  renderDevWarning() {
    if (!isDevelopment) {
      return null
    }
    return (
      <div className={`${scope}-DevelopmentWarning`}>
        <div className={`${scope}-DevelopmentWarning-Title`}>We're doing it live!</div>
        This site is currently in development mode, and may not behave as expected.
        <br />
        We're probably streaming as we design this, so you're welcome to{' '}
        <a
          target='_blank'
          rel='noopener noreferrer'
          href='https://www.twitch.tv/silencedraconem'
          title='Silence on Twitch'
        >
          hop on by
        </a>
        !
      </div>
    )
  }

  render() {
    // console.log('Page Props: ', this.props)
    const { children, className } = this.props
    return (
      <div className={classnames(scope, className)}>
        <div className={`${scope}-CircleLarge`} />
        <div className={`${scope}-CircleSmall`} />
        <img alt='' className={`${scope}-Logo`} src='/logo.png' />
        <Helmet>
          <title>{this._createTitle()}</title>
        </Helmet>
        <ConfigManager />
        <Header {...this.props} />
        {this.renderDevWarning()}
        {children}
        <Footer {...this.props} />
      </div>
    )
  }
}

Page.propTypes = {
  config: PropTypes.object,
  title: PropTypes.string,
}

export default Page



// WEBPACK FOOTER //
// ./src/components/common/page/page.jsx